<div class="product-image-upload-root">
    <img *ngIf="picture.value" src="{{picture.value}}" alt="product-image">
    <button mat-flat-button color="primary" (click)="openUpdateImageModal()">
        <div class="button-wrapper">
            <nb-icon icon="upload-outline"></nb-icon>Upload
        </div>
    </button>
</div>
